import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";

export const ListItem = ({item, onDeleteClick}) => {

    return (
        <div className="list-item-container">
            <div className="list-item">
                {item}
            </div>
            <div className="list-item-delete-button" aria-label={"list-delete"} onClick={onDeleteClick}>
                <FontAwesomeIcon className="list-item-delete-icon" icon={faTimes}/>
            </div>
        </div>
    );
}
